import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';
import { Button, Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function AbwesenheitenPopover({
  abwesenheiten,
}: {
  abwesenheiten: Abwesenheit[];
}) {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 639px)');
    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost-primary" size="icon">
          <FontAwesomeIcon icon={faCircleInfo} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        side={isMobile ? 'bottom' : 'right'}
        className="p-4 flex flex-col gap-2 text-sm bg-white w-full md:min-w-[340px]">
        <div className="font-semibold">
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.abwesenheitPopover.title',
          )}
        </div>
        {abwesenheiten.map((abwesenheit) => (
          <div
            key={abwesenheit.id}
            className="flex justify-between items-center gap-4">
            <div className="flex items-center gap-2">
              <FontAwesomeIcon
                className="mr-0.5"
                icon={abwesenheit.abwesenheitsgrundIcon}
              />
              <div className="truncate">{abwesenheit.grund}</div>
            </div>
            <div className="font-semibold">{abwesenheit.zeitraumLabel}</div>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
